module.exports = __webpack_public_path__ + "static/media/namecard_with_question_marks.10edd6c8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/namecard_with_question_marks.svg
 ** module id = 372
 ** module chunks = 44
 **/